<template>
  <div class="help-wrap">
    <div class="w">
      <divider chinese="悦心康智慧实训中心" english="TRAINING CENTER"/>
      <div class="help-main">
        <div class="tabs">
          <div class="tabs-pane" @click="handleTabsClick(index)" :class="index === active ? 'active' : ''" v-for="(item, index) in tabs" :key="item.id">{{item.name}}</div>
        </div>
        <div class="tabs-content">
          <transition-group name="slide-left">
            <div class="content" v-show="index === active ? true : false" v-for="(item, index) in content" :key="item.id">
              <div class="title-wrap">
                <!-- <h6>{{item.title}}</h6> -->
                <p>{{item.introduction}}</p>
                <img :src="item.img" alt="">
              </div>
              <!-- <div class="card-wrap">
                <div class="card-item" v-for="(i, j) in item.card" :key="j">
                  <h6>{{i.title}}</h6>
                  <p>{{i.introduction}}</p>
                </div>
              </div> -->
            </div>
          </transition-group>
        </div>
        <div class="help-banner">
          <img src="@/assets/images/helpbanner.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import divider from '../divider'
export default {
  data () {
    return {
      tabs: [
        {name: '职业能力训练中心', id: 1},
        {name: '职业素养提升训练中心', id: 2},
        {name: '职业心理调适中心', id: 3},
        {name: '就创业模拟体验中心', id: 4}
        // {name: "智慧就业", id: 4},
        // {name: "智能科技", id: 5},
        // {name: "智慧教育", id: 6},
      ],
      content: [
        {
          id: 1,
          title: '职业能力训练中心',
          introduction: '结合职业能力评估方案，采用专业的训练仪器，开展职业能力专项训练。主要针对个体动作的力量、方向、幅度、速度方面，综合反应能力方面，注意分配、双手协调、手眼协调能力方面，空间位置记忆广度、数字记忆广度、短时记忆、长时记忆、瞬时记忆等职业能力以及逻辑思维能力方面，开展综合训练。所有训练设备，可与悦心康智慧云平台实现数据交互。设备的训练数据，在平台上进行汇总、分析、对比，自动形成训练报告。通过报告，发现个体职业能力发展的趋势，为进一步开展相应职业能力训练服务提供数据支撑。',
          img: require('@/assets/images/zhuli1.jpg')
          // card: [
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   },
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   },
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   }
          // ]
        },
        {
          id: 2,
          title: '职业素养提升训练中心',
          introduction: '职业素养是指职业内在的规范和要求,是在职业过程中表现出来的综合品质，包含职业道德、职业技能、职业行为、职业作风和职业意识等方面。 职业素养是人类在社会活动中需要遵守的行为规范。个体行为的总合构成了自身的职业素养，职业素养是内涵，个体行为是外在表象。所以，职业素养是一个人职业生涯成败的关键因素。职业素养量化而成“职商。”英文career quotient 简称CQ。也可以说一生成败看职商。本中心采用一对多的多媒体互动教学形式，为个体提供海量职业素养提升课程。课程注重在职业形象、基本知识、职业行为、职业技能、职业意识、职业道德、职业作风和职业态度等方面进行针对性的训练。',
          img: require('@/assets/images/zhuli2.jpg')
          // card: [
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   },
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   },
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   }
          // ]
        },
        {
          id: 3,
          title: '职业心理调适中心',
          introduction: '在当前社会就业形势十分严峻的条件下，无论是当代大学生，还是再就业者，在其他各种心理因素的共同作用下所形成的自卑、自负、焦虑、孤傲等一系列就业心理问题，已经越来越影响他们的学习、生活、社会交往等活动。采用专业的仪器设备，开展职业心理综合评估，进行职业状态调节，尤其焦虑心理、自卑心理、怯懦心理、孤傲心理、冷漠心理、迷茫心理等显著职业心理问题，开展心理减压，情绪疏导，自信引导等训练，帮助个体正确认识自我，能够坦然面对压力。',
          img: require('@/assets/images/zhuli3.jpg')
          // card: [
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   },
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   },
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   }
          // ]
        },
        {
          id: 4,
          title: '就创业模拟体验中心',
          introduction: '通过沙盘模拟的形式，体验真实企业的创立过程，完成创业计划书、办理工商税务登记注册、对创立企业进行运营管理等决策。通过对真实创业环境的逼真模拟，帮助个体掌握在真实企业创业过程中可能遇到的各种情况与经营决策，并对出现的问题和运营结果进行分析与评估，使个体对创业有更真实的体验与更深刻的理解。针对创业者的综合实训推演教学工具，解决创业者在初期“无中生有”的阶段中资源短缺、资金不足、信息不畅、企业系统化建设缺失、市场开拓困难等问题，帮助创业者系统梳理创业过程，提升创业意识与创业基础知识的灵活运用能力。通过模拟创业者经历的创业储备期、种子期、发展期、成长期的整个创业过程，让创业者在模拟中认识创业、建立创业意识、拓展创业思路，提升对创业各环节与关键点的把握能力，最终提高创业成功率。',
          img: require('@/assets/images/zhuli4.jpg')
          // card: [
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   },
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   },
          //   {
          //     title: 'AI创新实验室',
          //     introduction: '以AI技术为核心打造涵盖线上教学平台、课程培训、实训项目及线下实验室、师资培训、教具教材、竞赛等为一体的创新教育实验室。'
          //   }
          // ]
        }
      ],
      active: 0
    }
  },
  methods: {
    handleTabsClick (index) {
      this.active = index
    }
  },
  components: {
    divider
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/sass/variable.sass';
.help-wrap {
  width: 100%;
  height: 744px;
  background: url("~@/assets/images/helpbg.png") no-repeat;
  background-size: cover;
  position:relative;
  overflow: hidden;
  .w {
    width: $el-center;
    margin: 0 auto;
    .help-main {
      margin-top: 40px;
      .tabs {
        display: flex;
        justify-content: space-around;
        border-bottom:1px solid #E5EAF1;
        .tabs-pane {
          font-size: 20px;
          padding-bottom: 20px;
          color:#1B1E3F;
          cursor: pointer;
          position:relative;
          &:after {
            content:'';
            border-bottom:2px solid $el-main-color;
            left:50%;
            right:50%;
            bottom:0px;
            transition: all .2s cubic-bezier(0, 0.98, 0.51, 0.93);
            position:absolute;
          }
          &:hover {
            color: $el-main-color;
          }
          &:hover:after {
            left: 0%;
            right: 0%;
          }
          &.active {
            color: $el-main-color;
          }
          &.active:after  {
            left: 0%;
            right: 0%;
          }
        }
      }
      .tabs-content {
        padding: 0 45px;
        .content {
          // display: none;
          // &.active {
          //   display: block;
          // }
          .title-wrap {
            display: flex;
            margin: 100px 0 0 0;
            p {
              width: 741px;
              margin-right: 20px;
              line-height: 36px;
              text-indent: 2em;
              color: #878A9C;
            }
            img {
              width: 368px;
              height: 208px;
              border: 1px solid $el-main-color;
            }
            // margin: 50px 0 60px 0;
            // h6 {
            //   font-size: 28px;
            //   color:#1B1E3F;
            //   margin-bottom: 10px;
            //   font-weight: 400;
            // }
            // p {
            //   font-size: 14px;
            //   color:#1B1E3F;
            // }
          }
          .card-wrap {
            display: flex;
            justify-content: space-between;
            .card-item {
              height: 160px;
              padding:0 45px;
              border-right: 1px solid #D8D8D8;
              &:nth-child(1) {
                padding-left: 0;
              }
              &:last-child {
                border-right: none;
              }
              h6 {
                font-size: 20px;
                color: #454763;
                font-weight: normal;
                margin: 20px 0 20px;
              }
              p {
                font-size: 14px;
                color: #A7ACBB;
              }
            }
          }
        }
      }
      .help-banner {
        height: 110px;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin: 0px -600px;
        img {
          height: 110px;
        }
      }
    }
  }
}
@keyframes slideInLeft {
  from {
    transform: translateY(20PX);
    opacity: 1;
  }
  to {
    transform: translateY(0PX);
    opacity: 1;
  }
}
.slide-left-enter-active {
  animation: slideInLeft 1s forwards;
}
</style>



// WEBPACK FOOTER //
// src/components/home/help.vue